import { Link } from "react-router-dom";
import { ArrowUpRight, LifeBuoy } from "lucide-react";
import { useLang } from "@/contexts/LangContext";
import { APP_ROUTES } from "@/const/appRoutes";

// "floating" sits over every signed-in screen; "inline" lives in the header where a corner
// button would cover a screen's own bottom-right control (the Studio send button).
export function GuidesFab({ variant = "floating" }) {
  const { t } = useLang();

  return (
    <Link
      to={APP_ROUTES.integrations}
      className={`guides-fab guides-fab-${variant}`}
      aria-label={t("guides_fab_aria")}
      title={t("guides_fab_aria")}
      data-testid={`guides-fab-${variant}`}
    >
      <span className="guides-fab-icon" aria-hidden="true">
        <LifeBuoy size={variant === "inline" ? 14 : 18} />
      </span>
      <span className="guides-fab-text">
        <span className="guides-fab-kicker">{t("guides_fab_kicker")}</span>
        <span className="guides-fab-label">{t("guides_fab_label")}</span>
      </span>
      <ArrowUpRight className="guides-fab-arrow" size={15} aria-hidden="true" />
    </Link>
  );
}
